import {
  get, post, put, remove,
} from '@api';
import { Store } from 'react-notifications-component';
import {
  COMMON_DATA_DELETE_FAIL,
  COMMON_DATA_DELETE_SUCCESS,
  COMMON_DATA_UPDATE_FAIL,
  COMMON_DATA_UPDATE_SUCCESS,
} from '../../constants/notification-settings';

export const FETCH_ORDER_TRIGGERS_START = 'FETCH_ORDER_TRIGGERS_START';
export const FETCH_ORDER_TRIGGERS_SUCCESS = 'FETCH_ORDER_TRIGGERS_SUCCESS';
export const FETCH_ORDER_TRIGGERS_FAIL = 'FETCH_ORDER_TRIGGERS_FAIL';

/**
 * Показывает ошибку из ответа бэкенда, если она есть (например, «identifier
 * занят» или «триггер замаплен в карту»), иначе — общий текст.
 */
const notifyFail = (fallback, error) => {
  const backendMessage = error?.response?.data?.message;
  Store.addNotification(backendMessage ? { ...fallback, message: backendMessage } : fallback);
};

/**
 * Загружает кастомные триггеры хранилища (для мёржа со встроенным каталогом
 * в редакторе карт order/fulfillment).
 */
export const fetchOrderTriggers = (storageId) => async (dispatch) => {
  dispatch({ type: FETCH_ORDER_TRIGGERS_START });
  try {
    const response = await get(`/orders-storage/${storageId}/triggers`);
    dispatch({ type: FETCH_ORDER_TRIGGERS_SUCCESS, payload: response.data });
  } catch (e) {
    dispatch({ type: FETCH_ORDER_TRIGGERS_FAIL, payload: e });
  }
};

/**
 * Создаёт кастомный триггер. `identifier` обязан начинаться с `custom.`
 * и быть глобально уникальным — иначе бэкенд вернёт 400.
 */
export const addOrderTrigger = ({ storageId, trigger }, translations) => async (dispatch) => {
  try {
    await post(`/orders-storage/${storageId}/triggers`, trigger);
    Store.addNotification(COMMON_DATA_UPDATE_SUCCESS(translations));
    dispatch(fetchOrderTriggers(storageId));
    return true;
  } catch (e) {
    notifyFail(COMMON_DATA_UPDATE_FAIL(translations), e);
    return false;
  }
};

/**
 * Обновляет только localizeInfos триггера — identifier неизменяем.
 */
export const updateOrderTrigger = ({ storageId, triggerId, localizeInfos }, translations) =>
  async (dispatch) => {
    try {
      await put(`/orders-storage/${storageId}/triggers/${triggerId}`, { localizeInfos });
      Store.addNotification(COMMON_DATA_UPDATE_SUCCESS(translations));
      dispatch(fetchOrderTriggers(storageId));
      return true;
    } catch (e) {
      notifyFail(COMMON_DATA_UPDATE_FAIL(translations), e);
      return false;
    }
  };

/**
 * Удаляет триггер. Бэкенд вернёт 400, если триггер замаплен в какую-либо карту.
 */
export const deleteOrderTrigger = ({ storageId, triggerId }, translations) => async (dispatch) => {
  try {
    await remove(`/orders-storage/${storageId}/triggers/${triggerId}`);
    Store.addNotification(COMMON_DATA_DELETE_SUCCESS(translations));
    dispatch(fetchOrderTriggers(storageId));
    return true;
  } catch (e) {
    notifyFail(COMMON_DATA_DELETE_FAIL(translations), e);
    return false;
  }
};
